<template lang="pug">
  .component.component-backoffice-system-configuration
    .row(v-for="(elem, index) in value")
      DeleteConf(@click="value.splice(index, 1)")
      .column(v-for="(val, inx) in elem")
        input(v-if="inx !== 'config' && inx !== 'default'", type="text", :placeholder="inx", v-model="value[index][inx]")
        ValidationConfig(v-else-if="inx !== 'default'", v-model="value[index]", validation-key="config")
</template>

<script>
  import ValidationConfig from './ValidationConfig'
  import DeleteConf from './DeleteConf'
  export default {
    name: 'SystemFieldsConfiguration',
    components: {DeleteConf, ValidationConfig},
    props: ['value']
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// SystemFieldsConfiguration.vue?71283d24